import React, { useState } from "react";
import { IoClose } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import Params from "../../config/Params";
import { downloadBlob, postMultipartWithAuthCall, simpleGetCall, simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { toast } from "react-toastify";

function ImportSubjects() {
  const [showclose, setShowClose] = useState();
  const { t } = useTranslation();
  const [file, setFile] = useState(null)


  const downloadImportFormat = () => {

    downloadBlob(ApiConfig.DOWNLOAD_SUBJECT_IMPORT_FORMAT, JSON.stringify({
      api_key: Params.api_key,
      customer_id: Params.customer_id,
    }), "Subject_Data_format")

  }

  const handleImport = () => {

    if (!file) {
      toast.error('Pleas Select File!')
      return
    }

    const formData = new FormData()

    formData?.append('form-data', file)

    postMultipartWithAuthCall(ApiConfig.IMPORT_TEACHER_DATA, formData).then((res) => {

      if (res?.result) {
        toast.success(res?.message)
      } else {
        toast.error(res?.message)
      }

    })

  }


  return (
    <div className="row edsys-table">
      <div className="col-sm-12">
        <div className="d-flex">
          <h5 className="mb-2 flex-grow-1">{t("Import Subjects")}</h5>
        </div>
        <div className="card">
          <div className="card-header">
            {showclose ? (
              <div className="div_Succesfull">
                <label>{t("Imported Successfully")}</label>
                <IoClose onClick={() => setShowClose(!showclose)} />
              </div>
            ) : null}

            <div className="form-group col-md-6">
              <label for="task-title">{t("Upload File")}</label>
              <input
                className="datepicker-here form-control digits"
                type="file"
                accept=".xls, .xlsx"
                onChange={(e) => setFile(e.target.files[0])}
              />
            </div>
            <div className="schedulebutton">
              <div className="">
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={handleImport}
                >
                  {t("Import")}
                </button>
              </div>
              <div className="">
                <button className="btn btn-primary" type="button"
                  onClick={downloadImportFormat}
                >
                  {t("Download Import Format")}
                </button>
              </div>
            </div>
            <div style={{ marginTop: "10px" }}>
              <label className="Instruction_label">
                {t("Please follow the instruction before uploading the file")} .
              </label>
              <ul className="Instruction_list">
                <li>  {t("Uploading file should be a xls file")}</li>
                <li>  {t("Date format is Year-Month-Date for example 2014-12-20")}.</li>
                <li>
                  {t("Successive rows should be filled out from first row onwords")} .
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ImportSubjects;
